import styled from 'styled-components';

export const Title = styled.div`
  max-width: 60rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  h1 {
    font-size: 3rem;
    line-height: 4.8rem;
    font-weight: 700;

    color: ${({ theme }) => theme.colors.gray7};

    margin-top: 1rem;
  }

  h3 {
    font-size: 1.25rem;
    line-height: 2rem;
    font-weight: 600;

    text-transform: uppercase;
    letter-spacing: 0.08em;

    color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 1400px) {
    h1 {
      font-size: 2.75rem;
      line-height: 4.55rem;
    }
  }

  @media (max-width: 768px) {
    width: 80%;

    h1 {
      font-size: 2.5rem;
      line-height: 4.3rem;
    }

    h3 {
      font-size: 1rem;
      line-height: 1.75rem;
    }
  }

  @media (max-width: 500px) {
    width: 80%;

    h1 {
      font-size: 2.25rem;
      line-height: 4rem;
    }
  }
`;
